/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type CreateSkillCategoryInput = {|
  name?: ?string,
  assignedSkills?: ?$ReadOnlyArray<?string>,
  csrfToken?: ?string,
  socketClientId?: ?string,
  clientMutationId?: ?string,
|};
export type createSkillCategoryMutationVariables = {|
  input: CreateSkillCategoryInput
|};
export type createSkillCategoryMutationResponse = {|
  +createSkillCategory: ?{|
    +skillCategory: ?{|
      +node: ?{|
        +id: string,
        +name: ?string,
      |}
    |}
  |}
|};
export type createSkillCategoryMutation = {|
  variables: createSkillCategoryMutationVariables,
  response: createSkillCategoryMutationResponse,
|};
*/


/*
mutation createSkillCategoryMutation(
  $input: CreateSkillCategoryInput!
) {
  createSkillCategory(input: $input) {
    skillCategory {
      node {
        id
        name
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "CreateSkillCategoryInput!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateSkillCategoryPayload",
    "kind": "LinkedField",
    "name": "createSkillCategory",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "SkillCategoryTypeEdge",
        "kind": "LinkedField",
        "name": "skillCategory",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "SkillCategory",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "createSkillCategoryMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "createSkillCategoryMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "createSkillCategoryMutation",
    "operationKind": "mutation",
    "text": "mutation createSkillCategoryMutation(\n  $input: CreateSkillCategoryInput!\n) {\n  createSkillCategory(input: $input) {\n    skillCategory {\n      node {\n        id\n        name\n      }\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '01b8438a9acf3b46494634d1f411b794';

module.exports = node;
